import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomTypeIncludedGuests(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<{ id: string; [key: string]: unknown }>>({
    queryKey: roomRateAvailabilityQueryKeys.includedGuests(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () =>
      (await ReservationService.getRoomTypeIncludedGuests(propertyId, roomTypeId, roomRateId)).result
        ?.included_guests ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
